<article class="mt-5 col-12">
    <header class="text-center">
        <h2 class="fs-5"><i>You Have Qualified for these Exclusive Limited-Time Offers!</i></h2>
    </header>
    <section id="container-section" class="container-section mb-5">
        <button (click)="handlerBack()" *ngIf="activeOffers != ''" class="custom-icon mt-4"><i
                class="fas fa-solid fa-chevron-left"></i></button>
        <button id="offer-button"
            *ngIf="(activeOffers == 'personal-loan' || activeOffers == '') && (viewButtonByOffers['personal-loan'].includes(OfferId) || viewButtonByOffers['personal-loan'].includes('0'))"
            (click)="handlerSelecteOffers($event)" data-action="personal-loan"
            class="btn btn-auth-custom border-0 mt-4 personal-loan">Personal Loans Tailored to Your Financial Goals
            >>></button>
        <button id="offer-button"
            *ngIf="(activeOffers == 'credit-cards' || activeOffers == '') && (viewButtonByOffers['credit-cards'].includes(OfferId) || viewButtonByOffers['credit-cards'].includes('0'))"
            (click)="handlerSelecteOffers($event)" data-action="credit-cards"
            class="btn btn-auth-custom border-0 mt-4 credit-cards">Your Ideal Credit Cards, Exclusively for You
            >>></button>
        <button id="offer-button"
            *ngIf="(activeOffers == 'cash-deals' || activeOffers == '') && (viewButtonByOffers['cash-deals'].includes(OfferId) || viewButtonByOffers['cash-deals'].includes('0'))"
            (click)="handlerSelecteOffers($event)" data-action="cash-deals"
            class="btn btn-auth-custom border-0 mt-4 cash-deals">Get Instant Access to Exclusive Cash Deals >>></button>
    </section>
    <section class="col-12 mt-4 text-center container-section-items">
        <div id="personal-loan" *ngIf="showPersonalLoanOffers" class="container-item">
            <h3 class="fs-6">Find the Best Loans in 2023 from $500-$20,000</h3>
            <ul>
                <li>Save money</li>
                <li>Financial flexibility</li>
                <li>Improve your credit score</li>
            </ul>
            <a class="custom-btn btn" href="https://www.cvrtrkpro.com/XCJPFQ/4L4J9LZ/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Apply Now</a>
        </div>
        <div id="personal-loan" *ngIf="showPersonalLoanOffers" class="container-item">
            <h3 class="fs-6">Personal Loans up to $100,000</h3>
            <ul>
                <li>Fast Results</li>
                <li>Flexible Terms</li>
                <li>Trusted Service</li>
            </ul>
            <a class="custom-btn btn" href="https://www.cvrtrkpro.com/XCJPFQ/4J4ZZ6N/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Learn More</a>
        </div>
        <div id="personal-loan" *ngIf="showPersonalLoanOffers" class="container-item">
            <h3 class="fs-6">Need Emergency Funds to Cover Expenses?</h3>
            <ul>
                <li>All Credit Types Accepted</li>
                <li>Get approved up to $5,000</li>
                <li>Loans in as little as 24 hours</li>
            </ul>
            <a class="custom-btn btn" href="https://www.cvrtrkpro.com/XCJPFQ/4THFX9F/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Apply Now</a>
        </div>
        <div id="personal-loan" *ngIf="showPersonalLoanOffers" class="container-item">
            <h3 class="fs-6">Personal Loans up to $2,500</h3>
            <ul>
                <li>Bad credit OK</li>
                <li>Loans that fit your financial needs</li>
                <li>Convenient payment options</li>
            </ul>
            <a class="custom-btn btn" href="https://www.cvrtrkpro.com/XCJPFQ/3ZMPBK8/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Learn More</a>
        </div>
        <div id="credit-cards" *ngIf="showCreditCardsOffers" class="container-item">
            <h3 class="fs-6">Search and Compare the Best Credit Cards</h3>
            <ul>
                <li>Bad credit OK</li>
                <li>Improve your credit score</li>
                <li>Financial flexibility</li>
            </ul>
            <a class="custom-btn btn" href="https://www.cvrtrkpro.com/XCJPFQ/3XWW3J5/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Apply Now</a>
        </div>
        <div id="credit-cards" *ngIf="showCreditCardsOffers" class="container-item">
            <h3 class="fs-6">Best Credit Cards in 2023 for Any Credit Type</h3>
            <ul>
                <li>Search and compare</li>
                <li>Cards that fit your needs</li>
                <li>Instant approval</li>
            </ul>
            <a class="custom-btn btn" href="https://www.cvrtrkpro.com/XCJPFQ/4L35DWC/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Learn More</a>
        </div>
        <div id="credit-cards" *ngIf="showCreditCardsOffers" class="container-item">
            <h3 class="fs-6">Search for the Most Strategic Credit Cards in 2023</h3>
            <ul>
                <li>Personalized results</li>
                <li>Find cards tailored to you</li>
                <li>All credit types accepted</li>
            </ul>
            <a class="custom-btn btn" href="https://www.cvrtrkpro.com/XCJPFQ/5X79454/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Apply Now</a>
        </div>
        <div id="credit-cards" *ngIf="showCreditCardsOffers" class="container-item">
            <h3 class="fs-6">The Best Cards for Less Than Perfect Credit</h3>
            <ul>
                <li>Find the right card for you</li>
                <li>Search cards by category</li>
                <li>Find the latest and best credit cards</li>
            </ul>
            <a class="custom-btn btn" href="https://www.cvrtrkpro.com/XCJPFQ/4DB2XHX/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Learn More</a>
        </div>
        <div id="cash-deals" *ngIf="showCashDealsOffers" class="container-item">
            <h3 class="fs-6">Enter to Win $25,000!</h3>
            <ul>
                <li>Pay off bills</li>
                <li>Take a vacation</li>
                <li>Make home improvements</li>
            </ul>
            <a class="custom-btn btn" href="https://www.cvrtrkpro.com/XCJPFQ/471GDQZ/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Enter Now</a>
        </div>
        <div id="cash-deals" *ngIf="showCashDealsOffers" class="container-item">
            <h3 class="fs-6">Unlock your $750 Cash App Gift Card!</h3>
            <ul>
                <li>$750 to your Cash App Account</li>
                <li>Claim Amazing Deals</li>
                <li>Take Surveys</li>
            </ul>
            <a class="custom-btn btn" href="https://www.bhmediatrack.com/XCJPFQ/4KBB5T8/?sub1=decline&sub2=&sub3=&{{UserInfo}}" target="_blank">Claim Now</a>
        </div>
    </section>
</article>